import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-documents-loader',
    imports: [CommonModule],
    standalone: true,
    templateUrl: './documents-loader.component.html',
    styleUrls: ['./documents-loader.component.scss']
})
export class DocumentsLoaderComponent {
    @Input() text: string = 'Processing documents';
    @Input() width: 'half' | 'full' = 'half';
    @Input() size: 'compact' | 'large' = 'compact';
    @Input() showText: boolean = true;
    @Input() numberOfDocuments: number = 8;

    get documentArray(): number[] {
        return Array(Math.max(1, Math.min(this.numberOfDocuments, 12))).fill(0).map((_, index) => index);
    }

    get containerClasses(): string {
        return `${this.width}-width ${this.size}`;
    }
}
